import { Backdrop, Fade, makeStyles, Modal } from "@material-ui/core";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faSearchPlus, faSearchMinus } from "@fortawesome/free-solid-svg-icons";
import { baseUrl } from "../auth/secret";
import { useCachedThumbnails } from "../helpers/storeIndexDB";

export default function PreviewImage(props) {
  const cachedThumbnails = useCachedThumbnails(props.image);
  const useStyles = makeStyles((theme) => ({
    gridList: {
      flexWrap: "nowrap",
      transform: "translateZ(0)",
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": {
        backgroundcolor: "red",
      },
    },
    img: {
      outline: "none",
    },
  }));
  const classes = useStyles();

  const [zoomLevel, setZoomLevel] = React.useState(0.8);

  const handleZoomIn = () => {
    setZoomLevel((prev) => Math.min(prev + 0.2, 3));
  };

  const handleZoomOut = () => {
    setZoomLevel((prev) => Math.max(prev - 0.2, 0.5));
  };

  const handleClose = () => {
    setZoomLevel(0.8);
    props.onToggle();
  };

  return (
    <Modal
      className={classes.modal}
      open={props.isOpen || false}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 300,
      }}
    >
      <Fade in={props.isOpen} timeout={300} className={classes.img}>
        <div style={{ position: "relative", userSelect: "none", width: "100%", height: "100%" }}>
          <div
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "20px",
              right: "20px",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              color: "white",
              width: "40px",
              height: "40px",
              borderRadius: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              zIndex: 1000,
            }}
          >
            <FontAwesomeIcon icon={faTimes} size="lg" />
          </div>

          <img
            key={props.image.timestamp}
            src={cachedThumbnails || `${baseUrl}${props.image}`}
            alt={props.timestamp}
            style={{
              position: "relative",
              top: "50%",
              left: "50%",
              maxHeight: "90vh",
              maxWidth: "90vw",
              transform: `translate(-50%, -50%) scale(${zoomLevel})`,
              transition: "transform 0.2s ease-in-out",
              userSelect: "none",
            }}
            loading="lazy"
            decoding="auto"
            draggable={false}
            onError={(e) => (e.target.src = "https://placehold.co/400x400?text=Placeholder")}
          />
          <div
            style={{
              position: "absolute",
              bottom: "20px",
              left: "50%",
              transform: "translateX(-50%)",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              padding: "10px",
              borderRadius: "20px",
              display: "flex",
              gap: "40px",
              userSelect: "none",
            }}
          >
            <FontAwesomeIcon icon={faSearchPlus} size="lg" onClick={handleZoomIn} style={{ color: "white", cursor: "pointer" }} />
            <FontAwesomeIcon icon={faSearchMinus} size="lg" onClick={handleZoomOut} style={{ color: "white", cursor: "pointer" }} />
          </div>
        </div>
      </Fade>
    </Modal>
  );
}
